// All workspace switcher copy. The functional Teams Pro PR (merged
// personal + team views) rewrites the "what switching does" lines here only.

export const PERSONAL_LABEL = "Personal";
// A team whose name is missing or couldn't be read (as TeamSidebarNav shows it).
export const TEAM_FALLBACK_LABEL = "Team";
export const PERSONAL_ROW_SECONDARY = "Only you";
export const INACTIVE_ROW_TOOLTIP =
  "Your access is paused — contact your team admin";
export const INACTIVE_ROW_SECONDARY = "Inactive — contact your admin";
// An admin whose own membership is inactive can turn it back on.
export const INACTIVE_ADMIN_ROW_SECONDARY = "Inactive — click to reactivate";
export const MANAGE_TEAM = "Manage team";
export const CREATE_TEAM = "Create a team";
// Under the plan cards' disabled team button, for users already on a team.
export const ONE_TEAM_ONLY = "You can't be in more than one team right now.";

// Trigger name while the team name loads.
export const WORKSPACE_LOADING_LABEL = "Workspace";

// The plan tag at the end of each row.
export const PLAN_TAG_FREE = "Free";
export const PLAN_TAG_PRO = "Pro";
export const PLAN_TAG_TEAM = "Pro Teams";

// One-time callout on the switcher for team users (switcherTip.ts).
export const SWITCHER_TIP_TITLE = "Switch workspaces here";
export const switcherTipBody = (teamName: string | null) =>
  `Use it to move between Personal and ${teamName ?? "your team"}.`;
export const SWITCHER_TIP_DISMISS = "Got it";

// Personal list pages, for team members: where shared items are (TeamWorkspaceBanner).
export const teamBannerTitle = (items: string) =>
  `Looking for ${items} shared with you?`;
// teamName null = more than one team.
export const teamBannerBody = (items: string, teamName: string | null) =>
  `Your team's ${items}, including ones teammates share with you, are in ${teamName ?? "your team workspaces"}.`;
export const teamBannerSwitch = (teamName: string) => `Switch to ${teamName}`;

/** "Team · 6 members", or just "Team" until the count loads. */
export const teamRowSecondary = (n?: number) =>
  n === undefined ? "Team" : `Team · ${n} member${n === 1 ? "" : "s"}`;
